// extracted by mini-css-extract-plugin
export default {"sectionRoot":"events__sectionRoot__HurH9"};